import React, { useEffect, useState } from 'react';
import './Header.css';
import { resolveEnv } from '../utils/subdomain';

// Tarja de ambiente: sinaliza QA e homologação em TODAS as páginas, porque o
// Header é montado uma vez acima das rotas. Só sinalização — as travas de
// feature seguem em isQaEnvironment(), exclusiva de "-qa".
const ENV_BANNERS = {
  qa:  { label: 'AMBIENTE DE QA',            className: 'env-banner--qa'  },
  hmg: { label: 'AMBIENTE DE HOMOLOGAÇÃO',   className: 'env-banner--hmg' },
};

const EnvBanner = () => {
  // Vale para QUALQUER tenant: admin-qa, leroymerlin-hmg, magalu-qa, etc.
  // Quem decide é só o sufixo do host, então nenhum tenant novo precisa de ajuste.
  const banner = ENV_BANNERS[resolveEnv()];

  // Duas páginas dimensionam por calc(100vh - 70px); a classe no body expõe a
  // altura da tarja para elas descontarem também.
  useEffect(() => {
    if (!banner) return undefined;
    document.body.classList.add('has-env-banner');
    return () => document.body.classList.remove('has-env-banner');
  }, [banner]);

  if (!banner) return null;
  return (
    <div className={`env-banner ${banner.className}`} role="status" aria-live="polite">
      {banner.label}
    </div>
  );
};

const roleLabels = {
  manager: 'Gerente',
  director: 'Diretor',
  supervisor: 'Supervisor',
};

const Header = ({
  storeName,
  user,
  onLogout,
  onMenuClick
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    setShowDropdown(false);
    onLogout();
  };

  return (
    <header className="header">
      <EnvBanner />

      <div className="header-container">
        {/* Logo e título */}
        <div className="header-brand">
          <button
            className="menu-toggle"
            onClick={onMenuClick}
            aria-label="Menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>

          <img
            src="/assets/aliado-logo.png"
            alt="Aliado"
            className="header-logo"
          />

          <div className="header-title">
            <h1>{storeName}</h1>
          </div>
        </div>

        {/* Informações do usuário */}
        <div className="header-user">
          <div className="user-info">
            <span className="user-name">{user?.username}</span>
            <span className="user-company">{user?.company}</span>
          </div>

          <div className="dropdown">
            <button
              className="dropdown-toggle"
              onClick={() => setShowDropdown(!showDropdown)}
              aria-label="Menu do usuário"
            >
              <div className="user-avatar">
                {user?.username?.charAt(0)?.toUpperCase() || 'U'}
              </div>
            </button>

            {showDropdown && (
              <div className="dropdown-menu">
                <div className="dropdown-header">
                  <strong>{user?.username}</strong>
                  <small>{user?.company}</small>
                  {user?.role && (
                    <small>{roleLabels[user.role] || user.role}</small>
                  )}
                  {user?.totalStores && (
                    <small>{user.totalStores} loja(s)</small>
                  )}
                </div>

                <div className="dropdown-divider"></div>

                <button
                  className="dropdown-item"
                  onClick={handleLogout}
                >
                  <span className="dropdown-icon">↗</span>
                  Sair
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;